import { makeAutoObservable } from 'mobx';

export enum DrawerType {
	DRAWER_ADDING,
	DRAWER_SORTING,
}

export class Drawers {
	current: DrawerType | null = null;

	constructor() {
		makeAutoObservable(this);
	}

	open = (type: DrawerType) => {
		this.current = type;
		console.log('Open', type);
	};

	toggle = (type: DrawerType) => {
		if (this.current === type) {
			this.close();
			return;
		}

		this.open(type);
	};

	close = () => {
		this.current = null;
	};

	isOpen = (type: DrawerType): boolean => {
		return this.current === type;
	};
}
